export const WORKFLOW_ENDPOINTS = {
    GET_TOKEN: '/workflow/token',
} as const;
